import React from 'react';
import { Section } from '../ui/Section';
import { Clock, Heart, Zap } from 'lucide-react';
export function SolutionSection() {
  return <Section background="dark" className="relative" data-id="element-131">
      {/* Subtle wave background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-5" data-id="element-132">
        <div className="absolute top-0 left-0 right-0 h-64 bg-gradient-to-b from-[#d4af37] to-transparent rounded-[100%] scale-x-150 translate-y-[-50%]" data-id="element-133" />
      </div>

      <div className="text-center mb-16" data-id="element-134">
        <h2 className="text-3xl md:text-4xl font-bold text-[#f5f0e8] mb-6" data-id="element-135">
          El cambio de juego:{' '}
          <span className="text-[#d4af37]" data-id="element-136">Timing + Secuencia</span>
        </h2>
        <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-137">
          No se trata de fuerza. Se trata de entender a tu cuerpo de noche.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-138">
        <div className="bg-[#1a1f2e] p-6 rounded-xl border border-[#2a3245] hover:border-[#d4af37]/30 transition-colors" data-id="element-139">
          <Clock className="w-10 h-10 text-[#d4af37] mb-4" data-id="element-140" />
          <h3 className="text-lg font-bold text-[#f5f0e8] mb-2" data-id="element-141">
            Tu cuerpo está sensible
          </h3>
          <p className="text-gray-400 text-sm" data-id="element-142">
            En la noche, tu umbral de dolor baja. Tu sistema está cansado y tu
            mente está sola.
          </p>
        </div>
        <div className="bg-[#1a1f2e] p-6 rounded-xl border border-[#2a3245] hover:border-[#d4af37]/30 transition-colors" data-id="element-143">
          <Zap className="w-10 h-10 text-[#d4af37] mb-4" data-id="element-144" />
          <h3 className="text-lg font-bold text-[#f5f0e8] mb-2" data-id="element-145">
            No "trabajes duro"
          </h3>
          <p className="text-gray-400 text-sm" data-id="element-146">
            La meta no es ejercitar la mano. La meta es calmarla antes de que
            suba el volumen del dolor.
          </p>
        </div>
        <div className="bg-[#1a1f2e] p-6 rounded-xl border border-[#2a3245] hover:border-[#d4af37]/30 transition-colors" data-id="element-147">
          <Heart className="w-10 h-10 text-[#d4af37] mb-4" data-id="element-148" />
          <h3 className="text-lg font-bold text-[#f5f0e8] mb-2" data-id="element-149">
            Anticipación
          </h3>
          <p className="text-gray-400 text-sm" data-id="element-150">
            Actuamos antes de la crisis. Preparamos el terreno para un descanso
            continuo.
          </p>
        </div>
      </div>

      <div className="bg-gradient-to-r from-[#1a1f2e] to-[#0f1419] p-8 md:p-12 rounded-2xl border border-[#d4af37]/20 text-center relative overflow-hidden" data-id="element-151">
        <div className="absolute top-0 right-0 w-32 h-32 bg-[#d4af37]/5 rounded-full blur-2xl" data-id="element-152" />

        <h3 className="text-2xl md:text-3xl font-serif font-bold text-[#f5f0e8] mb-4" data-id="element-153">
          Ahí entra <span className="text-[#d4af37]" data-id="element-154">CALMAR-12</span>
        </h3>
        <p className="text-gray-300 max-w-2xl mx-auto mb-8" data-id="element-155">
          Una rutina diseñada específicamente para la fisiología nocturna de
          manos con artritis o dolor crónico.
        </p>
      </div>
    </Section>;
}